import React from "react";
import DashboardV2 from "./components/DashboardV2";

export default function App(){
  return <DashboardV2 />;
}